<div *ngIf="expenseForm" class="form-modal">
  <h1 mat-dialog-title>{{'LINE_DETAILS'|translate}}</h1>
  <div mat-dialog-content>
    <div class="row no-margin-top">
      <div class="col-md-12 col-sm-12">
        <div class="content no-padding">
          <form [formGroup]="expenseForm" class="form-horizontal">
            <div class="row no-margin-top">
              <div class="col-sm-12">
                <mat-tab-group (selectedTabChange)="onSelectTab($event)">
                  <!-- **** CABECALHO **** -->
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span>{{ 'HEADER' | translate}}</span>
                    </ng-template>

                    <div class="row">
                      <!-- Panel identificacao da linha -->
                      <div class="col-sm-12">
                        <div class="panel panel-default">
                          <div class="panel-heading clearfix pointer" data-toggle="collapse"
                            data-target="#collDetailPn1" (click)="collDetailPn1 = !collDetailPn1">
                            <h5 class="panel-title">
                              <i class="fas fa-tasks"></i>
                              <strong>{{ 'EXPENSE' | translate}}</strong>
                              <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collDetailPn1, 'fa-caret-up': !collDetailPn1}"></i>
                            </h5>
                          </div>
                          <div id="collDetailPn1" class="panel-body no-horizontal-padding collapse in">
                            <div class="form-group">
                              <!-- Estado -->
                              <div class="col-md-2 col-sm-12" *ngIf="model.ID">
                                <mat-form-field class="allwidth" *ngIf="expensesStates">
                                  <mat-label>{{ 'STATE' | translate }}</mat-label>
                                  <mat-select formControlName="ExpenseState">
                                    <mat-option value=""></mat-option>
                                    <mat-option *ngFor="let expenseState of expensesStates" [value]="expenseState.ID">
                                      {{ expenseState.Name }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>

                              <!--Numero de documento-->
                              <div class="col-md-2 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'DOCUMENT_NUMBER' | translate }}</mat-label>
                                  <input matInput formControlName="DocumentNumber" class="one" />
                                </mat-form-field>
                                <error [control]="expenseForm.get('DocumentNumber')"></error>
                              </div>

                              <!--Fornecedor-->
                              <div class="col-md-2 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'NIF' | translate }}</mat-label>
                                  <input matInput formControlName="SupplierTaxNumber" class="one" />
                                  <i matSuffix class="fas fa-external-link-alt" (click)="openSupplier()" *ngIf="expenseForm.get('StateIsEditable').value || !model.ID"></i>
                                </mat-form-field>
                                <error [control]="expenseForm.get('SupplierTaxNumber')"></error>
                              </div>

                              <!-- Tipo -->
                              <div class="col-md-2 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'EXPENSE' | translate}}</mat-label>
                                  <mat-select formControlName="ExpenseType">
                                    <mat-option value=""></mat-option>
                                    <mat-option *ngFor="let expenseType of expensesTypes" [value]="expenseType.ID">
                                      {{ expenseType.Name }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <error [control]="expenseForm.get('ExpenseType')"></error>
                              </div>

                              <!-- Data da Despesa -->
                              <div class="col-md-2 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'DOCUMENT_DATE' | translate}}</mat-label>
                                  <input matInput formControlName="ExpenseDate" class="one date-picker" [tipoDateTime]="1">
                                  <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                                </mat-form-field>
                                <error [control]="expenseForm.get('ExpenseDate')"></error>
                              </div>


                              <!-- Botão para indicar se é reembolso -->
                              <div class="col-md-2 col-sm-12" *ngIf="_expenseService.showRefundButton">
                                <button type="button" class="btn no-margin-left" 
                                [ngClass]="{ 'btn-success' : expenseForm.get('Refund').value === true, 'btn-primary' : expenseForm.get('Refund').value === false}" 
                                  title="{{'REFUND' | translate}}" (click)="toggleRefund()" [disabled]="expenseForm.get('Refund').disabled">
                                  {{'REFUND' | translate}}&nbsp;
                                  <i class="fas mt-5" [ngClass]="{'fa-check-square' : expenseForm.get('Refund').value === true, 'fa-times-circle' : expenseForm.get('Refund').value === false}"></i>
                                </button>
                              </div>

                              <!-- Descrição -->
                              <div class="col-md-12 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'DESCRIPTION' | translate}}</mat-label>
                                  <input matInput
                                    formControlName="Description">
                                </mat-form-field>
                                <error [control]="expenseForm.get('Description')"></error>
                              </div>

                              <div class="spacer col-sm-12"
                                *ngIf="(!expenseForm.get('FileName').value && expenseForm.controls.StateIsEditable.value) || expenseForm.get('FileName').value ">
                              </div>

                              <div class="col-sm-12"
                                *ngIf="!expenseForm.get('FileName').value && expenseForm.controls.StateIsEditable.value else comFicheiro">
                                <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="hasBaseDropZoneOver=$event" [uploader]="uploader" class="well my-drop-zone no-margin" (click)="inputFile.click()">
                                  {{ 'DROP_AREA_DOCUMENT' | translate }}
                                </div>
                                <input type="file" ng2FileSelect [uploader]="uploader" #inputFile class="hide"
                                  (change)="addFile($event)" [accept]="" />
                                <!--accept=".tiff,.tif,.jpg"-->
                              </div>

                              <ng-template #comFicheiro>
                                <ng-container *ngIf="expenseForm.get('FileName').value">
                                  <div class="col-md-11 col-sm-10">
                                    <mat-form-field class="full-width">
                                      <mat-label>{{ 'FILE' | translate}}</mat-label>
                                      <input matInput formControlName="FileName">
                                    </mat-form-field>
                                    <error [control]="expenseForm.get('FileName')"></error>
                                  </div>
                                  <div class="col-md-1 col-sm-2">
                                    <div class="inline-flex flex-end">
                                      <!-- Botão Fazer Download do Ficheiro -->
                                      <button type="button"
                                        (click)="onDownloadFile(expenseForm.controls.FileID.value, expenseForm.controls.FileName.value)"
                                        class="btn btn-white pull-right"
                                        style="margin-top: 12px;padding: 2px 4px 2px 4px;"
                                        *ngIf="expenseForm.controls.FileID.value && expenseForm.controls.FileName.value">
                                        <span title="{{'BUTTON.DOWNLOAD' | translate}}">
                                          <i class="fas fa-download color-success backwhite"></i>
                                        </span>
                                      </button>

                                      <!-- Botão Remover Ficheiro -->
                                      <button type="button" (click)="removeFile()" class="btn btn-white pull-right"
                                        style="margin-top: 12px;padding: 2px 4px 2px 4px;" *ngIf="expenseForm.enabled">
                                        <span title="{{'BUTTON.DELETE' | translate}}">
                                          <i class="far fa-trash-alt red backwhite"></i></span>
                                      </button>
                                    </div>
                                  </div>
                                </ng-container>

                              </ng-template>
                              <div class="col-sm-12">
                                <error [control]="expenseForm.get('FileName')"></error>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Panel quantidade -->
                      <div class="col-sm-12">
                        <div class="panel panel-default">
                          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn2" (click)="collPn2 = !collPn2">
                            <h5 class="panel-title">
                              <i class="fas fa-tasks"></i>
                              <strong>{{ 'QUANTITIES' | translate}}</strong>
                              <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn2, 'fa-caret-up': !collPn2}"></i>
                            </h5>
                          </div>
                          <div id="collPn2" class="panel-body no-horizontal-padding collapse in">
                            <div class="form-group">
                              <!-- Qtd encomendada -->
                              <div class="col-md-3 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'QUANTITY' | translate }}</mat-label>
                                  <input matInput format formControlName="Quantity" class="text-right one" (change)="onQuantityChange()"/>
                                </mat-form-field>
                                <error [control]="expenseForm.get('Quantity')"></error>
                              </div>
                              <!-- Qtd encomendada UM -->
                              <div class="col-md-3 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>UM</mat-label>
                                  <mat-select name="QuantityUOMCode" formControlName="QuantityUOMCode">
                                    <mat-option [value]="null"></mat-option>
                                    <mat-option *ngFor="let inUn of expenseUnMeasureG" [value]="inUn.Code">
                                      {{inUn.Name}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <error [control]="expenseForm.get('QuantityUOMCode')"></error>
                              </div>
                              <!-- Qtd encomendada UM outra -->
                              <div class="col-md-3 col-md-2 col-sm-12"
                                *ngIf="expenseForm.get('QuantityUOMCode').value == 'Other'">
                                <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': !expenseForm.controls.QuantityUOMOther.valid}">
                                  <mat-label>UM - {{ 'OTHER' | translate}}</mat-label>
                                  <input matInput formControlName="QuantityUOMOther">
                                </mat-form-field>
                                <error [control]="expenseForm.get('QuantityUOMOther')"></error>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Panel precos -->
                      <div class="col-sm-12">
                        <div class="panel panel-default">
                          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn3" (click)="collPn3 = !collPn3">
                            <h5 class="panel-title">
                              <i class="fas fa-tasks"></i>
                              <strong>{{ 'PRICES' | translate}}</strong>
                              <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn3, 'fa-caret-up': !collPn3}"></i>
                            </h5>
                          </div>
                          <div id="collPn3" class="panel-body no-horizontal-padding collapse in">
                            <div class="form-group">

                              <!-- Preço Unitário -->
                              <div class="col-md-3 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'NET_UNIT_PRICE' | translate }}</mat-label>
                                  <input matInput format formControlName="NetUnitPrice" class="text-right one"
                                   (change)="onChangeNetUnitPrice()"/>
                                </mat-form-field>
                                <error [control]="expenseForm.get('NetUnitPrice')"></error>
                              </div>

                              <!-- Percentagem % -->
                              <div class="col-md-3 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'VAT_RATE' | translate }}</mat-label>
                                  <mat-select formControlName="TaxRate"
                                    (selectionChange)="onChangePercentage();" class="text-right one">
                                    <!--Mostra a label mensagem ao selecionar uma opção do mat-select-->
                                    <mat-select-trigger>
                                      {{ expenseForm.get("TaxRate").value }} ({{ expenseForm.get("TaxAmount").value }}{{ _cur_symbol }})
                                    </mat-select-trigger>

                                    <mat-option></mat-option>
                                    <mat-option *ngFor="let tax of expenseValueAddedTaxes" [value]="tax.TaxPercentage">
                                      {{ tax.TaxPercentage }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <error [control]="expenseForm.get('TaxRate')"></error>
                              </div>

                              <!-- Preço Total -->
                              <div class="col-md-3 col-sm-12">
                                <mat-form-field class="allwidth">
                                  <mat-label>{{ 'NET_TOTAL' | translate }}</mat-label>
                                  <input matInput format formControlName="TotalNetAmount" class="text-right one"
                                    (change)="onChangeTotalNetAmount()" />
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Observações -->
                      <div class="col-sm-12">
                        <div class="panel panel-default">
                          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn4"
                            (click)="collPn4 = !collPn4">
                            <h5 class="panel-title">
                              <i class="fas fa-sticky-note"></i>
                              <strong>{{ "OBSERVATIONS" | translate }}</strong>
                              <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn4, 'fa-caret-up': !collPn4}"></i>
                            </h5>
                          </div>

                          <div id="collPn4" class="panel-body no-horizontal-padding collapse in">
                            <div class="form-group">
                              <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                  <textarea matInput formControlName="Notes" rows="3"></textarea>
                                </mat-form-field>
                                <error [control]="expenseForm.get('Notes')"></error>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </mat-tab>

                  <!-- **** ARQUIVO DIGITAL **** -->
                  <mat-tab id="tabDigitalArchive" [disabled]="expenseForm.get('ID').value === 0">
                    <ng-template mat-tab-label>
                      <span>{{'ATTACHMENTS'|translate}}</span>
                    </ng-template>
                    <div class="spacer"></div>
                    <app-digarc-tab *ngIf="showArqTab_open" [context]="'ExpenseRepositoryDiskFile'"
                      [contextID]="model.ID" [allowDelete]="expenseForm.controls.StateIsEditable.value"
                      [allowCreate]="expenseForm.controls.StateIsEditable.value"
                      [contextGenericType]="'ExpenseRepositoryDiskFile'"></app-digarc-tab>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="full-width text-right modal-theme" *ngIf="expenseForm.enabled">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
        (click)="resetForm();_dialogRef.close(null)">
        {{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="!formDisabled" type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}"
        (click)="save()">
        {{'BUTTON.SAVE' | translate}}
      </button>
    </div>

    <div class="full-width text-right modal-theme" *ngIf="expenseForm.disabled">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="_dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>